import { Flex, Spin } from 'antd'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from './useAuth'

/**
 * Himoyalangan marshrutlar qobig'i.
 *
 * `me` yuklanmaguncha ichkarisi CHIZILMAYDI — bu shunchaki chiroyli yuklanish
 * emas, TALAB: tenant valyutasi `me` javobidan keladi va u modul darajasidagi
 * o'zgaruvchida saqlanadi (`AuthProvider` dagi izoh). Erta chizilsa summalar
 * zaxira valyutada chiqib, keyin sakrab o'zgaradi.
 */
export function RequireAuth() {
  const { isAuthenticated, isLoading } = useAuth()
  const location = useLocation()

  if (isLoading) {
    return (
      <Flex align="center" justify="center" style={{ minHeight: '100vh' }}>
        <Spin size="large" />
      </Flex>
    )
  }

  if (!isAuthenticated) {
    // Qaerga bormoqchi bo'lgani saqlanadi — kirgandan keyin o'sha yerga
    // qaytariladi, bosh sahifaga emas
    return <Navigate to="/login" replace state={{ from: location }} />
  }

  return <Outlet />
}
